import { createStyles, makeUiStyles } from "../styles/styles";
import { StylesIndexInjections } from "common-react";

export default makeUiStyles(() => createStyles({
  root: {
    position: 'absolute',
    left: -10000,
    top: 'auto',
    width: 1,
    height: 1,
    overflow: 'hidden',

    '&:focus, &:active': {
        position: 'static',
        width: 'auto',
        height: 'auto'
    }
  }
}), { name: 'VisuallyHidden', index: StylesIndexInjections.UI_ATOMS });
